export type StrippedUndefined<T extends Record<string, unknown>> = { [K in keyof T]: Exclude<T[K], undefined> };
/**
 * Strips all the properties that are `property: undefined`
 * This helps when some libraries dont treat missing and undefined properties the same
 *
 * @param obj - The object to strip undefined properties of
 * @returns The object with all fields that `=== undefined` removed
 */
export function stripUndefined<T extends Record<string, unknown>>(obj: T): StrippedUndefined<T> {
    return Object.keys(obj).reduce((acc, key) => {
        if (obj[key] !== undefined) {
            (acc as any)[key] = obj[key];
        }
        return acc;
    }, {}) as StrippedUndefined<T>;
}
